export const LOAD_DASHBOARD_PAGE = 'LOAD_DASHBOARD_PAGE'
